<script setup lang="ts">
/**
 * Per ADR-0047. The chat-bubble strip a `simulated_call_transcript`
 * proposal renders. Pulled out of AICopilotSheet.vue so both the
 * `artifact_walkthrough` composite proposal and the `before`/`after`
 * pair card reuse the same markup beneath their wrappers without
 * duplicating it.
 */
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { normalizeSimulatedCallExchange } from '@/lib/copilot-proposal-rendering';

const props = defineProps<{
  exchange?: unknown;
}>();

const { t } = useI18n();
const turns = computed(() => normalizeSimulatedCallExchange(props.exchange));
</script>

<template>
  <div v-if="turns.length > 0" class="flex flex-col gap-2">
    <div
      v-for="(turn, idx) in turns"
      :key="idx"
      class="flex"
      :class="turn.role === 'caller' ? 'justify-start' : 'justify-end'"
    >
      <div
        class="max-w-[85%] rounded-lg px-3 py-2 text-[13px]"
        :class="
          turn.role === 'caller'
            ? 'bg-bg border border-border text-text'
            : 'bg-primary/10 border border-primary/30 text-text'
        "
      >
        <div class="text-[10px] font-medium opacity-60 mb-0.5">
          {{
            turn.role === 'caller'
              ? t('components.copilot.simulatedCall.caller')
              : t('components.copilot.simulatedCall.agent')
          }}
        </div>
        <div class="whitespace-pre-wrap leading-snug">{{ turn.text }}</div>
      </div>
    </div>
  </div>
  <div v-else class="rounded-lg border border-dashed border-border bg-bg/50 px-3 py-2 text-xs text-text-muted">
    {{ t('components.copilot.simulatedCall.empty') }}
  </div>
</template>
